import Reservations from '../src/containers/Reservations'

export default Reservations
